
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lgDo7", function(module, exports) {

$parcel$export(module.exports, "UniformEntryPage", function () { return $84c3366e54b9b039$export$f0d4a992b207ed41; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dWbel = parcelRequire("dWbel");

var $4ktyF = parcelRequire("4ktyF");

var $luVwe = parcelRequire("luVwe");
parcelRequire("8ch47");
var $9AjEB = parcelRequire("9AjEB");

var $9iWJ8 = parcelRequire("9iWJ8");
const $84c3366e54b9b039$export$f0d4a992b207ed41 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const [dxpMigrationExposureFired, fireDxpMigrationExposure] = (0, $9iWJ8.useExperimentExposure)((0, $9iWJ8.experiments).dxpMigrationSoftwarePage);
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $iSvIT.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: "pageRender",
            actionSubject: "uniformPage",
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $iSvIT.useEffect)(()=>{
        // @ts-ignore
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType("paint");
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === "first-contentful-paint");
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === "first-contentful-paint");
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        "paint"
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn("Error measuring Page Render Time:", error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!dxpMigrationExposureFired) fireDxpMigrationExposure();
    }, [
        dxpMigrationExposureFired,
        fireDxpMigrationExposure
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $luVwe.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            "data-testid": "uniform-entry-page-root",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9AjEB.UniformEntryPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground,
                    isAllowPostMessage: isAllowPostMessage
                })
            })
        })
    });
};

});
parcelRegister("luVwe", function(module, exports) {

$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $7767538b4499ca14$export$580adf4c24c28053; });
// @ts-ignore

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $eXdLM = parcelRequire("eXdLM");
const $7767538b4499ca14$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                    isShowTryNowLink: true,
                    tryNowLinkCtaButtonColor: "light_grey",
                    productKey: "404"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eXdLM.MainSection), {})
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});

parcelRegister("8ch47", function(module, exports) {

$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return (parcelRequire("9AjEB")).UniformEntryPageTemplate; });

var $9AjEB = parcelRequire("9AjEB");

});
parcelRegister("9AjEB", function(module, exports) {

$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return $c0c979c21b492ce7$export$8328465fb6b6a7d2; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $4ktyF = parcelRequire("4ktyF");

var $luVwe = parcelRequire("luVwe");

var $aME7P = parcelRequire("aME7P");
const $c0c979c21b492ce7$export$8328465fb6b6a7d2 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $luVwe.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aME7P.UniformWrapper), {
            composition: composition,
            isUniformPlayground: isUniformPlayground,
            isAllowPostMessage: isAllowPostMessage
        })
    });
};

});



parcelRegister("f788Q", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $513b3aabfa44d17f$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $jpi63 = parcelRequire("jpi63");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-eab5e61327";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $513b3aabfa44d17f$var$BASE_URL = "https://www.atlassian.com";
const $513b3aabfa44d17f$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $513b3aabfa44d17f$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $k2OeR.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "canonical",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "alternate",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $513b3aabfa44d17f$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $loA2J.jsx)("link", {
                        rel: "alternate",
                        href: `${$513b3aabfa44d17f$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jpi63.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("dyrzP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("9Kv7x")).ContentPlatformImage; });

var $9Kv7x = parcelRequire("9Kv7x");

});
parcelRegister("9Kv7x", function(module, exports) {

$parcel$export(module.exports, "ContentPlatformImage", function () { return $ecf502f0947f1c39$export$f8e4eb6f7b9af79c; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $bhreu = parcelRequire("bhreu");
const $ecf502f0947f1c39$export$f8e4eb6f7b9af79c = (_param)=>{
    var { contentType: contentType, src: src, alt: alt, baseWidth: baseWidth } = _param, rest = (0, $akGnX._)(_param, [
        "contentType",
        "src",
        "alt",
        "baseWidth"
    ]);
    const queryPairs = [];
    let srcSet = [];
    if (contentType === "image/png") {
        queryPairs.push("fm=webp");
        if (baseWidth) {
            srcSet = (0, $bhreu.getSrcSet)(src, baseWidth, queryPairs, "w");
            queryPairs.push(`w=${baseWidth}`);
        }
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join("&")}` : "";
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", (0, $6iHNw._)((0, $7Knp0._)({
        loading: "lazy"
    }, rest), {
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(",") : undefined,
        alt: alt
    })));
};

});


parcelRegister("6O6jV", function(module, exports) {

$parcel$export(module.exports, "AgileVideo", function () { return $e10046294791441a$export$a01c1a169afc755c; });
/* agile-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
const $e10046294791441a$var$PlayIcon = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        className: (0, $esG4f.default)([
            "_lswu12e0 _kqswstnw _1e02idpf _rjxpidpf _152tidpf _u7coidpf _19pk1wug _2hwx1wug _otyr1wug _18u01wug",
            "play-icon"
        ]),
        width: "70px",
        height: "70px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M16,0 C7.163444,-5.41083001e-16 1.082166e-15,7.163444 0,16 C-1.082166e-15,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,11.7565362 30.3142906,7.68687356 27.3137085,4.6862915 C24.3131264,1.68570945 20.2434638,2.5983722e-16 16,0 Z M11.1288889,22.2222222 L11.1288889,9.77777778 L23.6533333,16 L11.1288889,22.2222222 Z"
        })
    });
};
const $e10046294791441a$export$a01c1a169afc755c = (props)=>{
    const { embedLink: embedLink, title: title, thumbnail: thumbnail } = props;
    const [isPlaying, setIsPlaying] = (0, $iSvIT.useState)(false);
    const bgImage = `url("${thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.url}")`;
    const videoOverlayCss = null;
    const iFrameCss = null;
    const videoDataEventProps = {
        "data-product-key": "jiraSoftware",
        "data-event-component": "linkButton",
        "data-event-container": "videoEmbedInline",
        "data-event": "clicked"
    };
    const handleClick = (e)=>{
        e.preventDefault();
        setIsPlaying(true);
    };
    const VideoSection = ()=>{
        const isIFrame = embedLink.includes("iframe");
        if (isIFrame) return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            dangerouslySetInnerHTML: {
                __html: embedLink
            },
            className: (0, $esG4f.default)([
                "_digdyfq0 _11av1ule _1stxbb7n _i01y1osq _91ut1wug _mi22p5ev"
            ])
        });
        else return /*#__PURE__*/ (0, $loA2J.jsx)("iframe", {
            width: "100%",
            height: "auto",
            src: $e10046294791441a$var$addAutoplay(embedLink),
            title: title,
            allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay;",
            allowFullScreen: true,
            "data-gtm-yt-inspected-12": "true",
            className: (0, $esG4f.default)([
                "_s7n4yfq0 _1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _3y3kp5ev"
            ])
        });
        return null;
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1reo15vq _18m915vq"
        ]),
        children: [
            !isPlaying && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1tke1osq _1bsb1osq _kqswh2mm _19itidpf _80omtlke _1reo15vq _18m915vq _1e0c1txw"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("a", (0, $6iHNw._)((0, $7Knp0._)({
                    className: (0, $esG4f.default)([
                        "_1e0c1ule _1bsb1osq _1tke1osq",
                        "play-trigger"
                    ]),
                    href: embedLink,
                    onClick: handleClick,
                    onKeyDown: ()=>setIsPlaying(true)
                }, videoDataEventProps), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                            src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAABFJREFUKBVjYBgFoyFAhRAAAAJJAAFEkgypAAAAAElFTkSuQmCC",
                            alt: thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.name,
                            className: (0, $esG4f.default)([
                                "_p12f1osq _1bsb1osq _4t3i1wug _8hrzaqso _t9ec1h7a _v5648pnm _1itk1n01 _1lrw1dfr _ouxl1ssb _bfhkygj1 _11q31n0t _s7n4yfq0 _irr3u67f _1llw1vf8"
                            ]),
                            style: {
                                "--_um3idz": (0, $43MIc.default)(bgImage)
                            }
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)($e10046294791441a$var$PlayIcon, {})
                    ]
                }))
            }),
            isPlaying && /*#__PURE__*/ (0, $loA2J.jsx)(VideoSection, {})
        ]
    });
};
const $e10046294791441a$var$addAutoplay = (url)=>{
    if (url.includes("?")) return `${url}&autoplay=1`;
    else return `${url}?autoplay=1`;
};

});

parcelRegister("krNyQ", function(module, exports) {

$parcel$export(module.exports, "RichTextComponent", function () { return $d64565553e7f2513$export$f7b0c3f1955f2d70; });
/* body-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $3FBn4 = parcelRequire("3FBn4");
// NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
const $d64565553e7f2513$var$richTextCss = null;
const $d64565553e7f2513$export$f7b0c3f1955f2d70 = (data)=>{
    const localeCode = (0, $3FBn4.useLocale)();
    const html = (0, $iSvIT.useMemo)(()=>{
        let initialHtml = data.text || ""; // Hacky stuff: Need to wrap tables in a div to make them scrollable
        const tableRegex = /<table[^>]*>[\s\S]*?<\/table>/g;
        const tableMatch = initialHtml.match(tableRegex);
        if (tableMatch) {
            const tableHtml = tableMatch[0];
            const newTableHtml = `<div class="table-wrapper">${tableHtml}</div>`;
            initialHtml = initialHtml.replace(tableHtml, newTableHtml);
        } // Hacky stuff pt2: Need to fix relative localized links
        const relativeLinkRegex = RegExp('(?:\\"https:\\/\\/\\/)(?<urlSlug>.+?)\\"', "g");
        initialHtml = initialHtml.replace(relativeLinkRegex, (_match, _p1, _offset, _string, groups)=>{
            return localeCode === (0, $3FBn4.DEFAULT_LOCALE) ? `"/${groups.urlSlug}"` : `"/${localeCode}/${groups.urlSlug}"`;
        }); // handle case where link is relative and not localized
        const relativeUrlRegex = new RegExp(`href="\\/(${localeCode}\\/)?([^"]*)"`, "g");
        initialHtml = initialHtml.replace(relativeUrlRegex, (_match, _p1, _p2)=>{
            // If the locale code is already present, return the match as is
            if (_p1) return _match; // Otherwise, prepend the locale code to the URL
            return localeCode === (0, $3FBn4.DEFAULT_LOCALE) ? `href="/${_p2}"` : `href="/${localeCode}/${_p2}"`;
        }); // handle case where absolute WAC links are not localized
        const absolutePathRegex = RegExp('\\"https:\\/\\/www\\.atlassian\\.com\\/(?![a-z]{2}\\/)(?<urlSlug>.+?)\\"', "g");
        initialHtml = initialHtml.replace(absolutePathRegex, (_match, _p1, _offset, _string, groups)=>{
            return localeCode === (0, $3FBn4.DEFAULT_LOCALE) ? `"/${groups.urlSlug}"` : `"/${localeCode}/${groups.urlSlug}"`;
        }); // Hacky stuff pt3: replace &amp;nbsp; with &nbsp;
        initialHtml = initialHtml.replace(/&amp;nbsp;/g, "&nbsp;").replace(/&amp;amp;/g, "&amp;");
        return initialHtml;
    }, [
        data.text,
        localeCode
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        dangerouslySetInnerHTML: {
            __html: html
        },
        className: (0, $esG4f.default)([
            "_q7gq1cby _zcqx1rqn _1v71idpf _1lmscfaq _1c56idpf _1s5ridpf _1glg12lh _1d9p1ule _1806idpf _1of3zh62 _1fr8ftgi _1160ftgi _lxprftgi _il49ftgi _xhev1e5h _o6n98xuz _1rm5idpf _1ht62e77 _wqy81e5h _1c2jj1oc _yb6gnqa1 _2b5et94y _p4li7vkz _owip7vkz _6aut7vkz _1pqw7vkz _134q1ule _1mjs1wug _22rsvbgk _1txxidpf _1gc1idpf _43dsrbzz _59381r31 _yha28stv _1nmznqa1 _5lhmtlke _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _2yrbagmp _43dz1u0t _5cr0h2mm _1dg11fu0 _1r7587ef _kbnuzwfg _1mcew6e8 _1frx1u0t _81wzyxqu _ui0gdlk8 _u0rjsusb _1ob3yxqu _1pubidpf _120wstnw _16g612gs _1ghd1h6o _1fhp1j6v _ha8hvwuj _14371k8s _1128bs82 _btqhidpf _1tadidpf _1ejb1tcg _1ahqidpf _172k12u0 _y5iq1lzr _olif1nu9 _r5plvwuj _1ipc1k8s _1yqebs82"
        ])
    });
};

});

parcelRegister("f0Hih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dhmEV")).default; });

var $dhmEV = parcelRequire("dhmEV");

});

parcelRegister("ZQ88u", function(module, exports) {

$parcel$export(module.exports, "isTextComponent", function () { return $b38aef75a4439eb4$export$4bf69398599dba31; });
$parcel$export(module.exports, "isAssetComponent", function () { return $b38aef75a4439eb4$export$61be03ff0b6c6c6e; });
$parcel$export(module.exports, "isEmbedComponent", function () { return $b38aef75a4439eb4$export$9846e8db24db36f4; });
$parcel$export(module.exports, "isProTipText", function () { return $b38aef75a4439eb4$export$cfaa1a75f40e26f5; });
$parcel$export(module.exports, "isTwitterComponent", function () { return $b38aef75a4439eb4$export$99fa2f2e7e0ad570; });
$parcel$export(module.exports, "isCallToAction", function () { return $b38aef75a4439eb4$export$ab20f6e6e266a5a6; });
$parcel$export(module.exports, "isQuestionComponent", function () { return $b38aef75a4439eb4$export$9c5fde415fc473c8; });
$parcel$export(module.exports, "isCallOutComponent", function () { return $b38aef75a4439eb4$export$a58e7eebbfe3c431; });
const $b38aef75a4439eb4$export$4bf69398599dba31 = (component)=>{
    return component.__typename === "ContentPlatformTextComponent" || component.__typename === "TextComponent";
};
const $b38aef75a4439eb4$export$61be03ff0b6c6c6e = (component)=>{
    return component.__typename === "ContentPlatformAssetComponent" || component.__typename === "AssetComponent";
};
const $b38aef75a4439eb4$export$9846e8db24db36f4 = (component)=>{
    return component.__typename === "ContentPlatformEmbeddedVideoAsset" || component.__typename === "EmbeddedVideoAsset";
};
const $b38aef75a4439eb4$export$cfaa1a75f40e26f5 = (component)=>{
    return component.__typename === "ContentPlatformProTipComponent" || component.__typename === "ProTipComponent";
};
const $b38aef75a4439eb4$export$99fa2f2e7e0ad570 = (component)=>{
    return component.__typename === "ContentPlatformTwitterComponent" || component.__typename === "TwitterComponent";
};
const $b38aef75a4439eb4$export$ab20f6e6e266a5a6 = (component)=>{
    return component.__typename === "ContentPlatformCallToAction" || component.__typename === "CallToAction";
};
const $b38aef75a4439eb4$export$9c5fde415fc473c8 = (component)=>{
    return component.__typename === "ContentPlatformQuestionComponent" || component.__typename === "QuestionComponent";
};
const $b38aef75a4439eb4$export$a58e7eebbfe3c431 = (component)=>{
    return component.__typename === "ContentPlatformCallOutComponent" || component.__typename === "CallOutComponent";
};

});

parcelRegister("iy4Sr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d80f2f7963c128c9$var$_react = $d80f2f7963c128c9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $d80f2f7963c128c9$var$_baseNew = $d80f2f7963c128c9$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $d80f2f7963c128c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d80f2f7963c128c9$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $d80f2f7963c128c9$var$_react.default.createElement($d80f2f7963c128c9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$d80f2f7963c128c9$var$OfficeBuildingIcon.displayName = "OfficeBuildingIcon";
var $d80f2f7963c128c9$var$_default = module.exports.default = $d80f2f7963c128c9$var$OfficeBuildingIcon;

});

parcelRegister("1lZ6p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fc726477ca8709d$var$_react = $0fc726477ca8709d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0fc726477ca8709d$var$_baseNew = $0fc726477ca8709d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0fc726477ca8709d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fc726477ca8709d$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $0fc726477ca8709d$var$_react.default.createElement($0fc726477ca8709d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$0fc726477ca8709d$var$InformationCircleIcon.displayName = "InformationCircleIcon";
var $0fc726477ca8709d$var$_default = module.exports.default = $0fc726477ca8709d$var$InformationCircleIcon;

});

parcelRegister("ayjUl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7aec85a235a3439c$var$_react = $7aec85a235a3439c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7aec85a235a3439c$var$_baseNew = $7aec85a235a3439c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $7aec85a235a3439c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7aec85a235a3439c$var$AddIcon = (props)=>/*#__PURE__*/ $7aec85a235a3439c$var$_react.default.createElement($7aec85a235a3439c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$7aec85a235a3439c$var$AddIcon.displayName = "AddIcon";
var $7aec85a235a3439c$var$_default = module.exports.default = $7aec85a235a3439c$var$AddIcon;

});

parcelRegister("c8hkI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3359cfcb124b9edec9402a579fa9711>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d53ad63e3caa159$var$_react = $8d53ad63e3caa159$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8d53ad63e3caa159$var$_baseNew = $8d53ad63e3caa159$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $8d53ad63e3caa159$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d53ad63e3caa159$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $8d53ad63e3caa159$var$_react.default.createElement($8d53ad63e3caa159$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$8d53ad63e3caa159$var$CheckboxCheckedIcon.displayName = "CheckboxCheckedIcon";
var $8d53ad63e3caa159$var$_default = module.exports.default = $8d53ad63e3caa159$var$CheckboxCheckedIcon;

});

parcelRegister("ft8Zd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b43088f9384ecc2c$var$_react = $b43088f9384ecc2c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b43088f9384ecc2c$var$_baseNew = $b43088f9384ecc2c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b43088f9384ecc2c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b43088f9384ecc2c$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $b43088f9384ecc2c$var$_react.default.createElement($b43088f9384ecc2c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$b43088f9384ecc2c$var$PeopleGroupIcon.displayName = "PeopleGroupIcon";
var $b43088f9384ecc2c$var$_default = module.exports.default = $b43088f9384ecc2c$var$PeopleGroupIcon;

});

parcelRegister("hlDQ4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0342603590f0e1a6$var$_react = $0342603590f0e1a6$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0342603590f0e1a6$var$_baseNew = $0342603590f0e1a6$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0342603590f0e1a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0342603590f0e1a6$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $0342603590f0e1a6$var$_react.default.createElement($0342603590f0e1a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$0342603590f0e1a6$var$CheckMarkIcon.displayName = "CheckMarkIcon";
var $0342603590f0e1a6$var$_default = module.exports.default = $0342603590f0e1a6$var$CheckMarkIcon;

});

parcelRegister("aRHrH", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("9O2F2")).IntercomProvider; });
parcelRequire("9O2F2");
parcelRequire("42XIn");

});
parcelRegister("9O2F2", function(module, exports) {

$parcel$export(module.exports, "IntercomProvider", function () { return $be094a112486886f$export$5091c5023e5c7eba; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $l4i0P = parcelRequire("l4i0P");

var $gkhN4 = parcelRequire("gkhN4");

var $7OS3I = parcelRequire("7OS3I");
const $be094a112486886f$var$isWindowExist = typeof window !== "undefined";
const $be094a112486886f$export$e578ca56db818a8e = /*#__PURE__*/ $iSvIT.createContext(undefined);
const $be094a112486886f$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $iSvIT.useRef(false);
    const isInit = $iSvIT.useRef(false);
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const initIntercomInstance = $iSvIT.useCallback(()=>{
        if (!isInit.current) {
            (0, $7OS3I.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $iSvIT.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $iSvIT.useCallback(async ()=>{
        if ($be094a112486886f$var$isWindowExist && isInit.current && !isBooted.current) {
            var _window_intercomSettings;
            const intercomSettings = (_window_intercomSettings = window.intercomSettings) !== null && _window_intercomSettings !== void 0 ? _window_intercomSettings : {
                app_id: appId
            };
            try {
                var _window_Intercom, _window, _window_Intercom1, _window1;
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "boot", (0, $7Knp0._)({
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher"
                }, intercomSettings));
                (_window_Intercom1 = (_window1 = window).Intercom) === null || _window_Intercom1 === void 0 ? void 0 : _window_Intercom1.call(_window1, "trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $iSvIT.useCallback(()=>{
        if (!isBooted.current) return;
        if ($be094a112486886f$var$isWindowExist) {
            var _window_Intercom, _window;
            (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $iSvIT.useCallback(()=>{
        var _window_Intercom, _window;
        if ($be094a112486886f$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "show");
    }, []);
    const hide = $iSvIT.useCallback(()=>{
        var _window_Intercom, _window;
        if ($be094a112486886f$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "hide");
    }, []);
    $iSvIT.useEffect(()=>{
        if ($be094a112486886f$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $l4i0P.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($be094a112486886f$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $iSvIT.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($be094a112486886f$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $be094a112486886f$export$28418e623d2470bc = ()=>{
    const context = $iSvIT.useContext($be094a112486886f$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("7OS3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f03bd135604494e$export$2e2bcd8739ae039; });
function $9f03bd135604494e$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $9f03bd135604494e$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            var _x_parentNode;
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x === null || x === void 0 ? void 0 : (_x_parentNode = x.parentNode) === null || _x_parentNode === void 0 ? void 0 : _x_parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($9f03bd135604494e$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $9f03bd135604494e$export$2e2bcd8739ae039 = $9f03bd135604494e$var$initializeIntercomInstance;

});


parcelRegister("42XIn", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("isSvf", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return (parcelRequire("lxS8L")).Video; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("lxS8L")).Video; });

var $lxS8L = parcelRequire("lxS8L");

});
parcelRegister("lxS8L", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $ed253e67f972fd3a$export$ae01dedf5c052bb; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $ed253e67f972fd3a$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $7Knp0._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
const $ed253e67f972fd3a$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $iSvIT.useEffect)(()=>{
        var _videoRef_current;
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $ed253e67f972fd3a$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});


parcelRegister("a0rKx", function(module, exports) {

$parcel$export(module.exports, "GuardLogo", function () { return $748f6df228342c19$export$a4a891d202775deb; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $748f6df228342c19$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 32" focusable="false" aria-hidden="true">\n      <path\n        d="M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038"\n        fill="'.concat(colors.iconColor, '"\n      />\n      <path\n        d="M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $748f6df228342c19$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Guard" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $748f6df228342c19$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1FqEx", function(module, exports) {

$parcel$export(module.exports, "useParentScrollTracking", function () { return $5f5c2bfbd45e6855$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $5f5c2bfbd45e6855$export$248f1dfc9396e7e4; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("ccYBS");
var $e6FyV = parcelRequire("e6FyV");
const $5f5c2bfbd45e6855$var$ScrollTrackingContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $5f5c2bfbd45e6855$export$164ddb76b909974a = ()=>{
    return (0, $iSvIT.useContext)($5f5c2bfbd45e6855$var$ScrollTrackingContext);
};
const $5f5c2bfbd45e6855$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $5f5c2bfbd45e6855$export$164ddb76b909974a();
    const arrayChildren = (0, $iSvIT.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $iSvIT.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    var _props_pageId;
    const pageId = (_props_pageId = props.pageId) !== null && _props_pageId !== void 0 ? _props_pageId : parentContext.pageId;
    return /*#__PURE__*/ (0, $loA2J.jsx)($5f5c2bfbd45e6855$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $iSvIT.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $e6FyV.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});
parcelRegister("ccYBS", function(module, exports) {
$parcel$export(module.exports, "ScrollTracking", function () { return (parcelRequire("e6FyV")).ScrollTracking; });
$parcel$export(module.exports, "useScrollTracking", function () { return (parcelRequire("e6FyV")).useScrollTracking; });
$parcel$export(module.exports, "withScrollTracking", function () { return (parcelRequire("e6FyV")).withScrollTracking; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return (parcelRequire("1FqEx")).ParentScrollTracking; });
parcelRequire("e6FyV");
parcelRequire("1FqEx");

});
parcelRegister("e6FyV", function(module, exports) {

$parcel$export(module.exports, "useScrollTracking", function () { return $dd17d79dac682b5f$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $dd17d79dac682b5f$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $dd17d79dac682b5f$export$391633ede08dabb1; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $eDoPe = parcelRequire("eDoPe");

var $g9kzu = parcelRequire("g9kzu");

var $1FqEx = parcelRequire("1FqEx");

var $dWbel = parcelRequire("dWbel");
const $dd17d79dac682b5f$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $iSvIT.useRef)(false);
    const scrollPercentage = (0, $iSvIT.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $1FqEx.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $eDoPe.useInView)((0, $6iHNw._)((0, $7Knp0._)({
        threshold: 0.5,
        triggerOnce: true
    }, observerOptions), {
        skip: (observerOptions === null || observerOptions === void 0 ? void 0 : observerOptions.skip) || !scrollTrackingEnabled
    }));
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $iSvIT.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $7Knp0._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: "ui",
                action: "dwellTimeTracked",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $7Knp0._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            if (analyticsClient) {
                createAnalyticsEvent((0, $7Knp0._)({}, scrollTrackAnalyticsPayload)).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    "mousemove",
                    "keydown",
                    "scroll",
                    "touchstart"
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent((0, $7Knp0._)({}, dwellTimeTrackAnalyticsPayload)).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $dd17d79dac682b5f$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $dd17d79dac682b5f$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $dd17d79dac682b5f$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)($dd17d79dac682b5f$export$1725757b7947b890, (0, $6iHNw._)((0, $7Knp0._)({
            section: section
        }, options), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)(InnerComponent, (0, $7Knp0._)({}, props))
        }));
    };
}

});



parcelRegister("7fq8b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $546e343250e73767$var$_react = $546e343250e73767$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $546e343250e73767$var$_baseNew = $546e343250e73767$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $546e343250e73767$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $546e343250e73767$var$BacklogIcon = (props)=>/*#__PURE__*/ $546e343250e73767$var$_react.default.createElement($546e343250e73767$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$546e343250e73767$var$BacklogIcon.displayName = "BacklogIcon";
var $546e343250e73767$var$_default = module.exports.default = $546e343250e73767$var$BacklogIcon;

});

parcelRegister("20L2t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $177011d2e77c7e3d$var$_react = $177011d2e77c7e3d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $177011d2e77c7e3d$var$_baseNew = $177011d2e77c7e3d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $177011d2e77c7e3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $177011d2e77c7e3d$var$DepartmentIcon = (props)=>/*#__PURE__*/ $177011d2e77c7e3d$var$_react.default.createElement($177011d2e77c7e3d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$177011d2e77c7e3d$var$DepartmentIcon.displayName = "DepartmentIcon";
var $177011d2e77c7e3d$var$_default = module.exports.default = $177011d2e77c7e3d$var$DepartmentIcon;

});

parcelRegister("aRydc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e896462d00fee46$var$_react = $7e896462d00fee46$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7e896462d00fee46$var$_baseNew = $7e896462d00fee46$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $7e896462d00fee46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e896462d00fee46$var$EditIcon = (props)=>/*#__PURE__*/ $7e896462d00fee46$var$_react.default.createElement($7e896462d00fee46$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$7e896462d00fee46$var$EditIcon.displayName = "EditIcon";
var $7e896462d00fee46$var$_default = module.exports.default = $7e896462d00fee46$var$EditIcon;

});

parcelRegister("g0xEi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba76bf61c8eefd7a$var$_react = $ba76bf61c8eefd7a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ba76bf61c8eefd7a$var$_baseNew = $ba76bf61c8eefd7a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ba76bf61c8eefd7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba76bf61c8eefd7a$var$PersonAddIcon = (props)=>/*#__PURE__*/ $ba76bf61c8eefd7a$var$_react.default.createElement($ba76bf61c8eefd7a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$ba76bf61c8eefd7a$var$PersonAddIcon.displayName = "PersonAddIcon";
var $ba76bf61c8eefd7a$var$_default = module.exports.default = $ba76bf61c8eefd7a$var$PersonAddIcon;

});

parcelRegister("eH5ui", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab29569377c90e7c$var$_react = $ab29569377c90e7c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ab29569377c90e7c$var$_baseNew = $ab29569377c90e7c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ab29569377c90e7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab29569377c90e7c$var$TeamsIcon = (props)=>/*#__PURE__*/ $ab29569377c90e7c$var$_react.default.createElement($ab29569377c90e7c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$ab29569377c90e7c$var$TeamsIcon.displayName = "TeamsIcon";
var $ab29569377c90e7c$var$_default = module.exports.default = $ab29569377c90e7c$var$TeamsIcon;

});

parcelRegister("lPup9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe45f21b5f8e4d30$var$_react = $fe45f21b5f8e4d30$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $fe45f21b5f8e4d30$var$_baseNew = $fe45f21b5f8e4d30$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $fe45f21b5f8e4d30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe45f21b5f8e4d30$var$BoardIcon = (props)=>/*#__PURE__*/ $fe45f21b5f8e4d30$var$_react.default.createElement($fe45f21b5f8e4d30$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$fe45f21b5f8e4d30$var$BoardIcon.displayName = "BoardIcon";
var $fe45f21b5f8e4d30$var$_default = module.exports.default = $fe45f21b5f8e4d30$var$BoardIcon;

});

parcelRegister("kqqsh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $edeac1c64e4915f3$var$_react = $edeac1c64e4915f3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $edeac1c64e4915f3$var$_baseNew = $edeac1c64e4915f3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $edeac1c64e4915f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $edeac1c64e4915f3$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $edeac1c64e4915f3$var$_react.default.createElement($edeac1c64e4915f3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$edeac1c64e4915f3$var$BookWithBookmarkIcon.displayName = "BookWithBookmarkIcon";
var $edeac1c64e4915f3$var$_default = module.exports.default = $edeac1c64e4915f3$var$BookWithBookmarkIcon;

});

parcelRegister("ctYD4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9167392384132023$var$_react = $9167392384132023$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9167392384132023$var$_baseNew = $9167392384132023$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9167392384132023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9167392384132023$var$CommentIcon = (props)=>/*#__PURE__*/ $9167392384132023$var$_react.default.createElement($9167392384132023$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$9167392384132023$var$CommentIcon.displayName = "CommentIcon";
var $9167392384132023$var$_default = module.exports.default = $9167392384132023$var$CommentIcon;

});

parcelRegister("jwsof", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e367072653dd9624$var$_react = $e367072653dd9624$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e367072653dd9624$var$_baseNew = $e367072653dd9624$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $e367072653dd9624$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e367072653dd9624$var$FileIcon = (props)=>/*#__PURE__*/ $e367072653dd9624$var$_react.default.createElement($e367072653dd9624$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$e367072653dd9624$var$FileIcon.displayName = "FileIcon";
var $e367072653dd9624$var$_default = module.exports.default = $e367072653dd9624$var$FileIcon;

});

parcelRegister("j25Ho", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddb29fee3dff1f48$var$_react = $ddb29fee3dff1f48$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ddb29fee3dff1f48$var$_baseNew = $ddb29fee3dff1f48$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ddb29fee3dff1f48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddb29fee3dff1f48$var$EmojiIcon = (props)=>/*#__PURE__*/ $ddb29fee3dff1f48$var$_react.default.createElement($ddb29fee3dff1f48$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$ddb29fee3dff1f48$var$EmojiIcon.displayName = "EmojiIcon";
var $ddb29fee3dff1f48$var$_default = module.exports.default = $ddb29fee3dff1f48$var$EmojiIcon;

});

parcelRegister("llWxg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8b8f712153f66c5$var$_react = $f8b8f712153f66c5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $f8b8f712153f66c5$var$_baseNew = $f8b8f712153f66c5$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $f8b8f712153f66c5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8b8f712153f66c5$var$FeedbackIcon = (props)=>/*#__PURE__*/ $f8b8f712153f66c5$var$_react.default.createElement($f8b8f712153f66c5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$f8b8f712153f66c5$var$FeedbackIcon.displayName = "FeedbackIcon";
var $f8b8f712153f66c5$var$_default = module.exports.default = $f8b8f712153f66c5$var$FeedbackIcon;

});

parcelRegister("foKoE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b35d164c36c1b05f$var$_react = $b35d164c36c1b05f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b35d164c36c1b05f$var$_baseNew = $b35d164c36c1b05f$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b35d164c36c1b05f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b35d164c36c1b05f$var$LightbulbIcon = (props)=>/*#__PURE__*/ $b35d164c36c1b05f$var$_react.default.createElement($b35d164c36c1b05f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$b35d164c36c1b05f$var$LightbulbIcon.displayName = "LightbulbIcon";
var $b35d164c36c1b05f$var$_default = module.exports.default = $b35d164c36c1b05f$var$LightbulbIcon;

});

parcelRegister("30lzE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23021b54e58d1b56$var$_react = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $23021b54e58d1b56$var$_baseNew = $23021b54e58d1b56$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $23021b54e58d1b56$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23021b54e58d1b56$var$RoadmapIcon = (props)=>/*#__PURE__*/ $23021b54e58d1b56$var$_react.default.createElement($23021b54e58d1b56$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$23021b54e58d1b56$var$RoadmapIcon.displayName = "RoadmapIcon";
var $23021b54e58d1b56$var$_default = module.exports.default = $23021b54e58d1b56$var$RoadmapIcon;

});

parcelRegister("cm6I6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8fecbea8f909d674$var$_react = $8fecbea8f909d674$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $8fecbea8f909d674$var$_baseNew = $8fecbea8f909d674$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $8fecbea8f909d674$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8fecbea8f909d674$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $8fecbea8f909d674$var$_react.default.createElement($8fecbea8f909d674$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$8fecbea8f909d674$var$EyeOpenIcon.displayName = "EyeOpenIcon";
var $8fecbea8f909d674$var$_default = module.exports.default = $8fecbea8f909d674$var$EyeOpenIcon;

});

parcelRegister("iThfY", function(module, exports) {

$parcel$export(module.exports, "CustomerDetailsStats", function () { return $b645e199078d01fe$export$60ec57d65c4d2d2b; });
/* customer-details-stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $5ohHq = parcelRequire("5ohHq");
const $b645e199078d01fe$var$containerStyle = null;
const $b645e199078d01fe$var$horizontalContainerWithThreeStatsStyle = null;
const $b645e199078d01fe$var$statsContainerStyle = null;
const $b645e199078d01fe$var$statStyle = null;
const $b645e199078d01fe$var$statTextStyle = null;
const $b645e199078d01fe$var$horizontalStatStyle = null;
const $b645e199078d01fe$var$horizontalStatTextStyle = null;
const $b645e199078d01fe$var$layoutStyle = null;
const $b645e199078d01fe$var$oneStatDesktopStyle = null; // Stat number color to be changed in the future to be dynamic based on the page-level accent color
const $b645e199078d01fe$var$isEmptyStats = (currentObject)=>JSON.stringify(currentObject) === "{}";
const $b645e199078d01fe$export$60ec57d65c4d2d2b = ({ title: title, stats: stats })=>{
    if (!stats || (stats === null || stats === void 0 ? void 0 : stats.every($b645e199078d01fe$var$isEmptyStats))) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1h6o _1bsb1osq _1wpz1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_2rkovwyg _1wpz1h6o _11q71rga _18zrxy5q _1e0c1txw _2lx21bp4 _zulp1ejb _1rjcxy5q _1bhl1ejb _2osnpxbi",
                (stats === null || stats === void 0 ? void 0 : stats.length) === 1 && "_glte12it _xtn71wug",
                (stats === null || stats === void 0 ? void 0 : stats.length) === 3 && "_glteqciz _u5ggze3t _xtn7ukr8"
            ]),
            style: {
                "--_19sjjnh": (0, $43MIc.default)((0, $5ohHq.wacToken)("corner.radius.card")),
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "eyebrow-md",
                    role: "heading",
                    "aria-level": 2,
                    children: title
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx2vrvc _zulpxy5q _2osn1ejb _1gde1bp4 _8164pxbi"
                    ]),
                    children: stats === null || stats === void 0 ? void 0 : stats.map((stat, idx)=>{
                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1e0c1txw _1wpz1fhb _16jlkb7n _i0dlidpf _2lx21bp4",
                                    (stats === null || stats === void 0 ? void 0 : stats.length) < 3 && "_1inivrvc _pdlmxy5q"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_1wpz1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                            (stats === null || stats === void 0 ? void 0 : stats.length) < 3 && "_cdjm1h6o",
                                            "stat-sm"
                                        ]),
                                        children: stat === null || stat === void 0 ? void 0 : stat.stat
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        className: (0, $esG4f.default)([
                                            "_1wpz1fhb _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                            (stats === null || stats === void 0 ? void 0 : stats.length) < 3 && "_cdjm1h6o",
                                            "body-md"
                                        ]),
                                        children: stat === null || stat === void 0 ? void 0 : stat.statDescription
                                    })
                                ]
                            })
                        }, idx);
                    })
                })
            ]
        })
    });
};

});

parcelRegister("bwE7U", function(module, exports) {

$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3f60c9aa58855bbf$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3f60c9aa58855bbf$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");
const $3f60c9aa58855bbf$var$logoWrapperStyles = null;
const $3f60c9aa58855bbf$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3f60c9aa58855bbf$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $f6qj2.default)();
    const ctaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.cta",
        defaultMessage: "Contact sales"
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: "EnterpriseLandingPage.navbar.mobile.cta",
        defaultMessage: "Contact sales"
    });
    const links = [
        {
            globalLinksKey: "overview",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.overview",
                defaultMessage: "Overview"
            }),
            hasSubnav: false,
            isActive: isActive == "overview",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise")
        },
        {
            globalLinksKey: "success",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.success",
                defaultMessage: "Success"
            }),
            hasSubnav: false,
            isActive: isActive == "success",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise/success")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "EnterpriseLandingPage.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            isActive: isActive == "resources",
            productKey: "enterprise",
            href: (0, $3FBn4.useLocalizedHref)("/enterprise/resources")
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: (0, $3FBn4.useLocalizedHref)("/enterprise"),
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3f60c9aa58855bbf$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "EnterpriseLandingPage.label",
                defaultMessage: "Enterprise"
            }),
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3f60c9aa58855bbf$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-enterprise",
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features"),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $3FBn4.useLocalizedHref)("/enterprise/contact?formType=product-features")
        })
    });
};
var $3f60c9aa58855bbf$export$2e2bcd8739ae039 = $3f60c9aa58855bbf$export$e36ad2737327f9c;

});

parcelRegister("hWh1T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd7e8572b743336ba9352499cfa665f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $035eca9539192339$var$_react = $035eca9539192339$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $035eca9539192339$var$_baseNew = $035eca9539192339$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $035eca9539192339$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $035eca9539192339$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $035eca9539192339$var$_react.default.createElement($035eca9539192339$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$035eca9539192339$var$ArrowUpIcon.displayName = "ArrowUpIcon";
var $035eca9539192339$var$_default = module.exports.default = $035eca9539192339$var$ArrowUpIcon;

});

parcelRegister("267hL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::481d1ea8ad85e9d7b0bddff8ba9b16d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1871cb1583e370a3$var$_react = $1871cb1583e370a3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $1871cb1583e370a3$var$_baseNew = $1871cb1583e370a3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $1871cb1583e370a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1871cb1583e370a3$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $1871cb1583e370a3$var$_react.default.createElement($1871cb1583e370a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$1871cb1583e370a3$var$ListChecklistIcon.displayName = "ListChecklistIcon";
var $1871cb1583e370a3$var$_default = module.exports.default = $1871cb1583e370a3$var$ListChecklistIcon;

});

parcelRegister("ko7jr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc58ff4eb916aa4715fd29d4da19740a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed7bb8ab02f4bb84$var$_react = $ed7bb8ab02f4bb84$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ed7bb8ab02f4bb84$var$_baseNew = $ed7bb8ab02f4bb84$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ed7bb8ab02f4bb84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed7bb8ab02f4bb84$var$ProjectIcon = (props)=>/*#__PURE__*/ $ed7bb8ab02f4bb84$var$_react.default.createElement($ed7bb8ab02f4bb84$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$ed7bb8ab02f4bb84$var$ProjectIcon.displayName = "ProjectIcon";
var $ed7bb8ab02f4bb84$var$_default = module.exports.default = $ed7bb8ab02f4bb84$var$ProjectIcon;

});

parcelRegister("fJ5Su", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c12e14f5c33454d538618fce8415497d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b72f9e363cfb0bc0$var$_react = $b72f9e363cfb0bc0$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b72f9e363cfb0bc0$var$_baseNew = $b72f9e363cfb0bc0$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b72f9e363cfb0bc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Megaphone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: feedback in products.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b72f9e363cfb0bc0$var$MegaphoneIcon = (props)=>/*#__PURE__*/ $b72f9e363cfb0bc0$var$_react.default.createElement($b72f9e363cfb0bc0$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3.096a.5.5 0 0 0-.686-.464L7.5 4.758v4.734l5.314 2.126a.5.5 0 0 0 .686-.464zm-6 8.012 4.757 1.903A2 2 0 0 0 15 11.154V3.096a2 2 0 0 0-2.743-1.857L6.606 3.5H3a2 2 0 0 0-2 2v3.25a2 2 0 0 0 2 2h.5V13a2 2 0 0 0 2 2h1.25a.75.75 0 0 0 .75-.75zM6 9.25H3a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 3 5h3zm0 1.5v2.75h-.5A.5.5 0 0 1 5 13v-2.25z" clip-rule="evenodd"/>`
    }, props));
$b72f9e363cfb0bc0$var$MegaphoneIcon.displayName = "MegaphoneIcon";
var $b72f9e363cfb0bc0$var$_default = module.exports.default = $b72f9e363cfb0bc0$var$MegaphoneIcon;

});

parcelRegister("4w8Rb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34a10561d56b8ab8$var$_react = $34a10561d56b8ab8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $34a10561d56b8ab8$var$_baseNew = $34a10561d56b8ab8$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $34a10561d56b8ab8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34a10561d56b8ab8$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $34a10561d56b8ab8$var$_react.default.createElement($34a10561d56b8ab8$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$34a10561d56b8ab8$var$RoadmapsPlanIcon.displayName = "RoadmapsPlanIcon";
var $34a10561d56b8ab8$var$_default = module.exports.default = $34a10561d56b8ab8$var$RoadmapsPlanIcon;

});

parcelRegister("7M1uQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a8e2d490a0851af$var$_react = $5a8e2d490a0851af$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5a8e2d490a0851af$var$_baseNew = $5a8e2d490a0851af$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5a8e2d490a0851af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a8e2d490a0851af$var$CalendarIcon = (props)=>/*#__PURE__*/ $5a8e2d490a0851af$var$_react.default.createElement($5a8e2d490a0851af$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$5a8e2d490a0851af$var$CalendarIcon.displayName = "CalendarIcon";
var $5a8e2d490a0851af$var$_default = module.exports.default = $5a8e2d490a0851af$var$CalendarIcon;

});

parcelRegister("2RWab", function(module, exports) {

$parcel$export(module.exports, "StrategyCollectionNavbar", function () { return $d5a5b968eec327c1$export$8f1cb1d63697797a; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $cP0Yq = parcelRequire("cP0Yq");

var $4R0f2 = parcelRequire("4R0f2");

var $b49hK = parcelRequire("b49hK");
const $d5a5b968eec327c1$export$8f1cb1d63697797a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.GlobalNav), {
        productKey: "home",
        compoundNav: (0, $6iHNw._)((0, $7Knp0._)({}, (0, $4R0f2.CollectionsCompoundSubNavProps)()), {
            ctaUrl: (0, $b49hK.CTA_URL_PATH)
        })
    });
};

});
parcelRegister("4R0f2", function(module, exports) {

$parcel$export(module.exports, "CollectionsCompoundSubNavProps", function () { return $265ebf1ac0867280$export$7390cb3961621991; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $3FBn4 = parcelRequire("3FBn4");

var $ispPN = parcelRequire("ispPN");

var $gAJUc = parcelRequire("gAJUc");

var $aOuDE = parcelRequire("aOuDE");
const $265ebf1ac0867280$export$7390cb3961621991 = ()=>{
    const intl = (0, $f6qj2.default)();
    const teamworkOverviewHref = (0, $3FBn4.useLocalizedHref)("/collections/teamwork");
    const teamworkFeaturesHref = (0, $3FBn4.useLocalizedHref)("/collections/teamwork/features");
    const teamworkPricingHref = (0, $3FBn4.useLocalizedHref)("/collections/teamwork/pricing");
    const strategyOverviewHref = (0, $3FBn4.useLocalizedHref)("/collections/strategy");
    const strategyDemoCenterHref = (0, $3FBn4.useLocalizedHref)("/collections/strategy/demo-center");
    const strategyPricingHref = (0, $3FBn4.useLocalizedHref)("/collections/strategy/pricing");
    const serviceHref = (0, $3FBn4.useLocalizedHref)("/collections/service");
    const softwareHref = (0, $3FBn4.useLocalizedHref)("/collections/software");
    const isGwp7850 = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7850GlobalNavChangesForTeam25Eu);
    const collectionsHref = (0, $3FBn4.useLocalizedHref)("/collections");
    // todo: GWP-8380 support collections subnav dropdown menu in mobile
    // 1024 == `media.below.md`, which is the mobile-display threshold
    // specified in services/wac-web/src/patterns/global-nav/src/nav-product-page.tsx
    const isMobile = (0, $aOuDE.useIsMobile)(1024);
    const hasSubnav = isGwp7850 && !isMobile;
    const props = {
        optionalClassName: isGwp7850 ? "collections-nav" : "",
        compoundSubNavTitle: "Collections",
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: "overview",
                linkText: intl.formatMessage({
                    id: "collectionsCompoundSubNav.Navlink.overview",
                    defaultMessage: "Overview"
                }),
                hasSubnav: false,
                href: collectionsHref
            },
            {
                globalLinksKey: "teamwork",
                linkText: "Teamwork",
                href: teamworkOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ispPN.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: teamworkOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.features",
                                        defaultMessage: "Features"
                                    }),
                                    href: teamworkFeaturesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: teamworkPricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: "strategy",
                linkText: "Strategy",
                href: strategyOverviewHref,
                hasSubnav: hasSubnav,
                content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ispPN.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.overview",
                                        defaultMessage: "Overview"
                                    }),
                                    href: strategyOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.demoCenter",
                                        defaultMessage: "Demo Center"
                                    }),
                                    href: strategyDemoCenterHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: "CollectionsCompoundSubNavProps.pricing",
                                        defaultMessage: "Pricing"
                                    }),
                                    href: strategyPricingHref
                                }
                            ]
                        }
                    ]
                })
            }
        ],
        isShowCta: isGwp7850 ? false : true,
        ctaButtonText: intl.formatMessage({
            id: "collectionsCompoundSubNav.cta.contactSales",
            defaultMessage: "Contact Sales"
        }),
        ctaButtonVariant: "primary",
        ctaUrl: "#contact"
    };
    if (isGwp7850) {
        props.compoundSubNavLinksProps.push({
            globalLinksKey: "service",
            linkText: "Service",
            hasSubnav: false,
            href: serviceHref
        }, {
            globalLinksKey: "software",
            linkText: "Software",
            hasSubnav: false,
            href: softwareHref
        });
        props.compoundSubNavLinksProps.shift();
    }
    return props;
};

});
parcelRegister("ispPN", function(module, exports) {

$parcel$export(module.exports, "DropdownContent", function () { return $16fe9e86fc1396d8$export$59308621e1a05692; });

var $9g0oR = parcelRequire("9g0oR");
const $16fe9e86fc1396d8$export$59308621e1a05692 = (0, $9g0oR.DropdownContent);

});


parcelRegister("b49hK", function(module, exports) {

$parcel$export(module.exports, "CTA_URL_PATH", function () { return $51d399db3476ba7f$export$d5587a12d9eea1dc; });
const $51d399db3476ba7f$export$d5587a12d9eea1dc = "/collections/strategy#contact";

});


parcelRegister("89oGH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ef250770984bd81$var$_react = $5ef250770984bd81$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5ef250770984bd81$var$_baseNew = $5ef250770984bd81$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5ef250770984bd81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ef250770984bd81$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $5ef250770984bd81$var$_react.default.createElement($5ef250770984bd81$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$5ef250770984bd81$var$ListBulletedIcon.displayName = "ListBulletedIcon";
var $5ef250770984bd81$var$_default = module.exports.default = $5ef250770984bd81$var$ListBulletedIcon;

});

parcelRegister("7lagR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5582762c7d38d6f5$var$_react = $5582762c7d38d6f5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5582762c7d38d6f5$var$_baseNew = $5582762c7d38d6f5$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5582762c7d38d6f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5582762c7d38d6f5$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $5582762c7d38d6f5$var$_react.default.createElement($5582762c7d38d6f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$5582762c7d38d6f5$var$ChartTrendIcon.displayName = "ChartTrendIcon";
var $5582762c7d38d6f5$var$_default = module.exports.default = $5582762c7d38d6f5$var$ChartTrendIcon;

});

parcelRegister("g8hkf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbead533cd4a5363$var$_react = $bbead533cd4a5363$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $bbead533cd4a5363$var$_baseNew = $bbead533cd4a5363$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $bbead533cd4a5363$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbead533cd4a5363$var$StarStarredIcon = (props)=>/*#__PURE__*/ $bbead533cd4a5363$var$_react.default.createElement($bbead533cd4a5363$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$bbead533cd4a5363$var$StarStarredIcon.displayName = "StarStarredIcon";
var $bbead533cd4a5363$var$_default = module.exports.default = $bbead533cd4a5363$var$StarStarredIcon;

});

parcelRegister("dsYmM", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", function () { return $3c36c2c0278568bb$export$e23ae35269442b4f; });
// Copy of search-ai/src/v2/common/ui/assets/Rovo.svg

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
const $3c36c2c0278568bb$export$e23ae35269442b4f = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", (0, $6iHNw._)((0, $7Knp0._)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.96666 0.28204C9.66095 -0.100922 10.5084 -0.0938864 11.197 0.303146L16.6126 3.42764L17.8968 4.16857C18.598 4.57283 19.032 5.32283 19.032 6.1308V13.8618C19.032 14.6729 18.6006 15.4196 17.8973 15.8237L12.8611 18.7293C12.8721 18.6984 12.8826 18.6672 12.8926 18.6358C12.9861 18.3462 13.0357 18.0401 13.0357 17.7272V9.99628C13.0357 8.93422 12.4704 7.95482 11.5484 7.425L10.6181 6.88854L7.79413 5.25997V2.26531C7.79413 2.02934 7.83064 1.79883 7.89972 1.58062C8.06955 1.05249 8.43078 0.595295 8.92495 0.309889L8.92645 0.309025C8.94061 0.300851 8.95409 0.291787 8.96666 0.28204Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M7.26173 1.27069L2.22547 4.17636C1.5222 4.5804 1.09082 5.32709 1.09082 6.13826V13.8692C1.09082 14.6772 1.52475 15.4271 2.22593 15.8314L3.42002 16.5203L8.9258 19.6969C9.61444 20.0939 10.4619 20.1009 11.1561 19.718C11.1687 19.7082 11.1821 19.6992 11.1963 19.6911C11.691 19.4058 12.0528 18.9485 12.2229 18.4201C12.2921 18.2017 12.3287 17.9709 12.3287 17.7347V14.7401L9.41444 13.0594L8.57469 12.5752C7.65284 12.0453 7.08715 11.0657 7.08715 10.0037V2.27277C7.08715 1.96035 7.13657 1.65469 7.2298 1.36539C7.23992 1.33362 7.25057 1.30205 7.26173 1.27069Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.41444 13.0594L3.42002 16.5203L2.22593 15.8314C1.52475 15.4271 1.09082 14.6772 1.09082 13.8692V6.13826C1.09082 5.32709 1.5222 4.5804 2.22547 4.17636L7.26173 1.27069C7.25057 1.30205 7.23992 1.33362 7.2298 1.36539C7.13657 1.65469 7.08715 1.96035 7.08715 2.27277V10.0037C7.08715 11.0657 7.65284 12.0453 8.57469 12.5752L9.41444 13.0594Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.6181 6.88854L7.79413 5.25997V2.26531C7.79413 2.02934 7.83064 1.79883 7.89972 1.58062C8.06955 1.05249 8.43078 0.595295 8.92495 0.309889L8.92645 0.309025C8.94061 0.300851 8.95409 0.291787 8.96666 0.28204C9.66095 -0.100922 10.5084 -0.0938864 11.197 0.303146L16.6126 3.42764L10.6181 6.88854Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8968 4.16857L16.6126 3.42764L10.6181 6.88854L11.5484 7.425C12.4704 7.95482 13.0357 8.93422 13.0357 9.99628V17.7272C13.0357 18.0401 12.9861 18.3462 12.8926 18.6358C12.8826 18.6672 12.8721 18.6984 12.8611 18.7293L17.8973 15.8237C18.6006 15.4196 19.032 14.6729 19.032 13.8618V6.1308C19.032 5.32283 18.598 4.57283 17.8968 4.16857Z",
                fill: "#AF59E1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.41444 13.0594L3.42002 16.5203L8.9258 19.6969C9.61444 20.0939 10.4619 20.1009 11.1561 19.718C11.1687 19.7082 11.1821 19.6992 11.1963 19.6911C11.691 19.4058 12.0528 18.9485 12.2229 18.4201C12.2921 18.2017 12.3287 17.9709 12.3287 17.7347V14.7401L9.41444 13.0594Z",
                fill: "#6A9A23"
            })
        ]
    }));
};

});

parcelRegister("3aCqg", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return (parcelRequire("gxFZp")).BitbucketNav; });
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return (parcelRequire("44Pau")).WhyBitbucketSubnav; });
parcelRequire("gxFZp");
parcelRequire("44Pau");

});
parcelRegister("gxFZp", function(module, exports) {

$parcel$export(module.exports, "BitbucketNav", function () { return $3fabb197901cb5ca$export$374e7235418bdbdb; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $5netJ = parcelRequire("5netJ");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
parcelRequire("3aCqg");
var $44Pau = parcelRequire("44Pau");
const $3fabb197901cb5ca$var$BitbucketLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $5netJ.BitbucketLogo), {
        appearance: "brand"
    });
};
const $3fabb197901cb5ca$export$374e7235418bdbdb = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=bitbucket&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).BITBUCKET,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const dataCenterHref = (0, $3FBn4.useLocalizedHref)("/software/bitbucket/enterprise/data-center");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/bitbucket/pricing");
    const links = [
        {
            globalLinksKey: "whyBitbucket",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.whyBitbucket",
                defaultMessage: "Why Bitbucket"
            }),
            productKey: "bitbucket",
            hasSubnav: true,
            dropdownType: "why-bitbucket"
        },
        {
            globalLinksKey: "self-hosted",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.selfhosted",
                defaultMessage: "Self-Hosted"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: dataCenterHref
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "bitbucket",
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-BitbucketNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productKey: "bitbucket",
            productLogoUrl: "/software/bitbucket",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3fabb197901cb5ca$var$BitbucketLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.bitbucket-logo",
                defaultMessage: "Bitbucket logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "BitbucketPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($3fabb197901cb5ca$var$BitbucketLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "whyBitbucket",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.whyBitbucket",
                        defaultMessage: "Why Bitbucket"
                    }),
                    containerStyles: {
                        width: "fit-content",
                        margin: 0
                    },
                    hasSubnav: true,
                    content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $44Pau.WhyBitbucketSubnav), {
                        productKey: "bitbucket"
                    })
                },
                {
                    globalLinksKey: "self-hosted",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.selfhosted",
                        defaultMessage: "Self-Hosted"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: dataCenterHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "BitbucketPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "bitbucket",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-bitbucket",
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});
parcelRegister("5netJ", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogo", function () { return $3e9a54e2937c19ed$export$bd40525f5333524b; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $3e9a54e2937c19ed$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n        <path fill='.concat(colors.iconColor, ' d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>\n        <path fill=').concat(colors.textColor, ' d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>\n      </svg>');
};
var $3e9a54e2937c19ed$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3e9a54e2937c19ed$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("44Pau", function(module, exports) {

$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return $9633d059a3ed42d2$export$7b115720fff1fb0d; });
/* why-bitbucket-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $3XIdt = parcelRequire("3XIdt");

var $baj2f = parcelRequire("baj2f");

var $jGfor = parcelRequire("jGfor");

var $hbBKK = parcelRequire("hbBKK");
function $9633d059a3ed42d2$var$useWhyBitbucketLinks() {
    return {
        features: {
            id: "solution",
            title: (0, $6x1qA.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.solution",
                defaultMessage: "Solution"
            }),
            items: [
                {
                    id: "ci-cd",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.work-management",
                        defaultMessage: "CI/CD"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/pipelines")
                },
                {
                    id: "cloud-security",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.cloud-security",
                        defaultMessage: "Cloud Security"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/cloud-security")
                },
                {
                    id: "dev-sec-ops",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.dev-sec-ops",
                        defaultMessage: "DevSecOps"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/devsecops")
                },
                {
                    id: "code-review",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.it-service-management",
                        defaultMessage: "Code Review"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/features/code-review")
                },
                {
                    id: "jira-integrations",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.agile-devops",
                        defaultMessage: "Jira Integrations"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/jira/bitbucket-integration")
                }
            ]
        },
        plans: {
            id: "plans",
            title: (0, $6x1qA.defineMessage)({
                id: "bitbucketnav.subnav.whybitbucket.links.plans",
                defaultMessage: "Plans"
            }),
            items: [
                {
                    id: "bitbucket-cloud-premium",
                    text: (0, $6x1qA.defineMessage)({
                        id: "bitbucketnav.subnav.whybitbucket.links.bitbucket-cloud-premium",
                        defaultMessage: "Bitbucket Cloud Premium"
                    }),
                    href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket/premium")
                }
            ]
        }
    };
}
const $9633d059a3ed42d2$export$7b115720fff1fb0d = ({ productKey: productKey = "bitbucket" })=>{
    const intl = (0, $f6qj2.default)();
    const bitbucketLinks = $9633d059a3ed42d2$var$useWhyBitbucketLinks();
    const linkColumns = Object.values(bitbucketLinks);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbBKK.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3XIdt.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_bfhk1rga"
                    ]),
                    style: {
                        "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $baj2f.RowGrid), {
                        numCols: 2,
                        columnGap: "var(--ds-space-500, 40px)",
                        paddingBlock: "var(--ds-space-500, 40px)",
                        paddingInline: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jGfor.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        className: (0, $esG4f.default)([
                                            "_1p1dangw _syaz1hlo _1wyboqnp _ect4bzd7 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                            "--_1ikmwd8": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.text"))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c11p5 _2z0510ma"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1hlo _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1hlo _oavv1ep1 _oxk41ep1 _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                                    "--_1pjqntz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue800"))
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        "data-event": "clicked",
                                                        "data-event-component": "linkButton",
                                                        "data-event-container": "globalNavSubnav",
                                                        "data-product-key": productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("hDoR2", function(module, exports) {

$parcel$export(module.exports, "CompassNav", function () { return $b48207cde0746e41$export$78e93448314ae49; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $7JG5H = parcelRequire("7JG5H");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
const $b48207cde0746e41$var$CompassLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $7JG5H.CompassLogo), {
        appearance: "brand"
    });
};
const $b48207cde0746e41$export$78e93448314ae49 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=compass&edition=free");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).COMPASS,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/compass/pricing");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-CompassNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: "/software/compass",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($b48207cde0746e41$var$CompassLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "CompassPageTemplate.navbar.compass-logo",
                defaultMessage: "Compass logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "CompassPageTemplate.navbar.getitfree",
                defaultMessage: "Get it Free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($b48207cde0746e41$var$CompassLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "features",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.features",
                        defaultMessage: "Features"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: (0, $3FBn4.useLocalizedHref)("/software/compass/features")
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "CompassPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "compass",
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-compass",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "features",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.features",
                                defaultMessage: "Features"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: (0, $3FBn4.useLocalizedHref)("/software/compass/features")
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "CompassPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "compass",
                            href: pricingHref
                        }
                    ]
                }
            ]
        })
    });
};

});
parcelRegister("7JG5H", function(module, exports) {

$parcel$export(module.exports, "CompassLogo", function () { return $5a1d62c42d86e741$export$eb7d748e4f9c9676; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $5a1d62c42d86e741$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n    <path fill='.concat(colors.iconColor, ' d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>\n    <path fill="').concat(colors.textColor, '" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>\n  </svg>');
};
var $5a1d62c42d86e741$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Compass" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5a1d62c42d86e741$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("4Cacz", function(module, exports) {

$parcel$export(module.exports, "GuardNav", function () { return $59641f41c7daf66c$export$941339143e9f5522; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $a0rKx = parcelRequire("a0rKx");

var $dyZbY = parcelRequire("dyZbY");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
const $59641f41c7daf66c$var$GuardLogoComponent = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $a0rKx.GuardLogo), {
        appearance: "brand"
    });
};
const $59641f41c7daf66c$export$941339143e9f5522 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = "https://admin.atlassian.com/atlassian-guard";
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = (0, $3FBn4.useLocalizedHref)("/software/guard/capabilities");
    const pricingHref = (0, $3FBn4.useLocalizedHref)("/software/guard/pricing");
    const guideHref = (0, $3FBn4.useLocalizedHref)("/software/guard/guide#getting-started");
    const demoHref = (0, $3FBn4.useLocalizedHref)("/software/guard/demo");
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "confluence-pt-cfind-1234-GuardNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: "/software/guard",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($59641f41c7daf66c$var$GuardLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: "GuardPageTemplate.navbar.guard-logo",
                defaultMessage: "Guard logo"
            }),
            mobileCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: "GuardPageTemplate.navbar.tryitfree",
                defaultMessage: "Try it free"
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($59641f41c7daf66c$var$GuardLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: "capabilities",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.capabilities",
                        defaultMessage: "Capabilities"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: capabilitiesHref
                },
                {
                    globalLinksKey: "pricing",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.pricing",
                        defaultMessage: "Pricing"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: pricingHref
                },
                {
                    globalLinksKey: "guide",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.guide",
                        defaultMessage: "Guide"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: guideHref
                },
                {
                    globalLinksKey: "demo",
                    linkText: intl.formatMessage({
                        id: "GuardPageTemplate.navbar.demo",
                        defaultMessage: "Demo"
                    }),
                    hasSubnav: false,
                    productKey: "guard",
                    href: demoHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-guard",
                    mobileLinksProps: [
                        {
                            globalLinksKey: "capabilities",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.capabilities",
                                defaultMessage: "Capabilities"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: capabilitiesHref
                        },
                        {
                            globalLinksKey: "pricing",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.pricing",
                                defaultMessage: "Pricing"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: pricingHref
                        },
                        {
                            globalLinksKey: "guide",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.guide",
                                defaultMessage: "Guide"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: guideHref
                        },
                        {
                            globalLinksKey: "demo",
                            linkText: intl.formatMessage({
                                id: "GuardPageTemplate.navbar.demo",
                                defaultMessage: "Demo"
                            }),
                            hasSubnav: false,
                            productKey: "guard",
                            href: demoHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("j6Axx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c253c89c6f96043e$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $i8kxh = parcelRequire("i8kxh");

var $3LLDq = parcelRequire("3LLDq");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $gAJUc = parcelRequire("gAJUc");
const $c253c89c6f96043e$var$JpdLogo = ()=>{
    const gwp7518NavIconUpdates = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp7518NavIconUpdates);
    return gwp7518NavIconUpdates ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand"
    });
};
const $c253c89c6f96043e$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $f6qj2.default)();
    const signupLink = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=jira-product-discovery");
    const { openCrossFlow: openCrossFlow } = (0, $3LLDq.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $i8kxh.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $i8kxh.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: "jiraproductdiscovery.navbar.product-features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/features")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: "jiraproductdiscovery.navbar.features",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/pricing")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "jiraproductdiscovery.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery/resources")
        }
    ];
    // TODO: this duplicates the value from the v1 product nav
    // this was to use an accurate existing translation for a Team'24 hot fix
    const ctaText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
        productLogoUrl: (0, $3FBn4.useLocalizedHref)("/software/jira/product-discovery"),
        productLogo: /*#__PURE__*/ (0, $loA2J.jsx)($c253c89c6f96043e$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: "wacJiraProductDiscoveryNavigation.logo-label",
            defaultMessage: "Jira Product Discovery logo"
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)($c253c89c6f96043e$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: "mobile-jira-product-discovery",
                mobileLinksProps: links
            }
        ]
    });
};
$c253c89c6f96043e$var$JiraProductDiscoveryNavV2.displayName = "JiraProductDiscoveryNavV2";
var $c253c89c6f96043e$export$2e2bcd8739ae039 = $c253c89c6f96043e$var$JiraProductDiscoveryNavV2;

});

parcelRegister("5ifyY", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionLogo", function () { return $3daab4b4ef34ab49$export$6e87ce8d41eda665; });
/* eslint-disable max-len */ 
var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $bLwq0 = parcelRequire("bLwq0");

var $eJjXw = parcelRequire("eJjXw");
var $3daab4b4ef34ab49$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $bLwq0.getColorsForLoom)(appearance, colorMode);
    return '<svg\n		fill="none"\n		height="32"\n		xmlns="http://www.w3.org/2000/svg"\n		focusable="false"\n		aria-hidden="true"\n		viewBox="0 0 88 32"\n	>\n		<path\n			d="M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058"\n			fill="'.concat(colors.iconColor, '"\n		/>\n		<path\n			d="M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z"\n			fill="').concat(colors.textColor, '"\n		/>\n	</svg>');
};
var $3daab4b4ef34ab49$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Loom Attribution" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $3daab4b4ef34ab49$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("g99nl", function(module, exports) {

$parcel$export(module.exports, "RovoNav", function () { return $5298b6428dc92303$export$f7b51e35c95f667c; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $bQiYD = parcelRequire("bQiYD");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $4XrxY = parcelRequire("4XrxY");

var $cP0Yq = parcelRequire("cP0Yq");

var $9g0oR = parcelRequire("9g0oR");

var $9iWJ8 = parcelRequire("9iWJ8");

var $gAJUc = parcelRequire("gAJUc");

var $5wOn9 = parcelRequire("5wOn9");
const $5298b6428dc92303$export$f7b51e35c95f667c = ()=>{
    var _userSegments_UserSegmentTypes_OWNED_PRODUCTS;
    const intl = (0, $f6qj2.default)();
    const navLinks = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/software/rovo/features")
        },
        {
            globalLinksKey: "connectors",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.connectors",
                defaultMessage: "Connectors"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/software/rovo/connectors")
        },
        {
            globalLinksKey: "use-cases",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.use-cases",
                defaultMessage: "Use cases"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/software/rovo/use-cases")
        },
        {
            globalLinksKey: "resources",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.resources",
                defaultMessage: "Resources"
            }),
            hasSubnav: true,
            productKey: "rovo",
            containerPosition: "relative",
            content: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9g0oR.DropdownContent), {
                orientation: "column",
                contentSections: [
                    {
                        links: [
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.ai-adoption-resources",
                                    defaultMessage: "AI adoption resources"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("http://community.atlassian.com/learning/hub/rovo")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.admin-onboarding",
                                    defaultMessage: "Admin onboarding"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("/software/rovo/guides/admin-guide")
                            },
                            {
                                text: intl.formatMessage({
                                    id: "RovoPageTemplate.navbar.resources.end-user-onboarding",
                                    defaultMessage: "End-user onboarding"
                                }),
                                href: (0, $3FBn4.useLocalizedHref)("/software/rovo/guides/end-user-guide")
                            }
                        ]
                    }
                ]
            })
        },
        {
            globalLinksKey: "licensing",
            linkText: intl.formatMessage({
                id: "RovoPageTemplate.navbar.licensing",
                defaultMessage: "Licensing"
            }),
            hasSubnav: false,
            productKey: "rovo",
            href: (0, $3FBn4.useLocalizedHref)("/licensing/rovo")
        }
    ];
    const { isUserLoggedIn: isUserLoggedIn, requestInProgress: requestInProgress } = (0, $5wOn9.useLoggedInUser)();
    const isRovoCtasEnabled = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8011RovoProductTour);
    const gwp8979RovoOnWacButtonEG = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).gwp8979RovoChatOnWac);
    const gwp8979RovoOnWacButtonFG = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8979RovoOnWacButton);
    const { data: userSegments } = (0, $bQiYD.useUserSegments)();
    const isRovoInPlanList = userSegments === null || userSegments === void 0 ? void 0 : (_userSegments_UserSegmentTypes_OWNED_PRODUCTS = userSegments[(0, $bQiYD.UserSegmentTypes).OWNED_PRODUCTS]) === null || _userSegments_UserSegmentTypes_OWNED_PRODUCTS === void 0 ? void 0 : _userSegments_UserSegmentTypes_OWNED_PRODUCTS.includes("rovo.ondemand");
    const defaultCTAUrl = (0, $3FBn4.useLocalizedHref)("/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium");
    const isUserLoggedInAndCtasEnabledAndInPlan = isUserLoggedIn && isRovoCtasEnabled && isRovoInPlanList;
    const isRovoEnabled = isUserLoggedInAndCtasEnabledAndInPlan || gwp8979RovoOnWacButtonEG.type === "enrolled" && gwp8979RovoOnWacButtonEG.value;
    const ctaText = isRovoEnabled ? intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.try-rovo",
        defaultMessage: "Try Rovo"
    }) : isRovoCtasEnabled ? intl.formatMessage({
        id: "RovoPageTemplate.navbar.cta.get-rovo",
        defaultMessage: "Get Rovo"
    }) : undefined;
    const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan ? "https://home.atlassian.com/chat" : isRovoCtasEnabled ? defaultCTAUrl : undefined;
    const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;
    const shouldShowCTAButtonVariant = gwp8979RovoOnWacButtonEG.type === "enrolled" && gwp8979RovoOnWacButtonEG.value && gwp8979RovoOnWacButtonFG;
    const buttonVariant = shouldShowCTAButtonVariant ? "secondary" : "primary";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "RovoNav",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.ProductPageSubNav), {
            productLogoUrl: "/software/rovo",
            productLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            productLogoAriaLabel: intl.formatMessage({
                id: "RovoPageTemplate.navbar.rovo-logo",
                defaultMessage: "Rovo logo"
            }),
            mobileLogo: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV3), {
                brand: "rovo",
                type: "logo",
                appearance: "brand"
            }),
            isShowTryNowLink: isShowTryNowLink,
            isIncludeMobileCTA: isShowTryNowLink,
            navigationTrynowCtaText: isShowTryNowLink ? ctaText : undefined,
            navigationTrynowCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            navigationTrynowCtaButtonVariant: buttonVariant,
            mobileCtaText: isShowTryNowLink ? ctaText : undefined,
            mobileCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            productPageNavLinks: navLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: "mobile-rovo",
                    mobileLinksProps: navLinks
                }
            ]
        })
    });
};

});

parcelRegister("9REvE", function(module, exports) {

$parcel$export(module.exports, "DropdownSelector", function () { return (parcelRequire("2m1xf")).DropdownSelector; });

var $2m1xf = parcelRequire("2m1xf");

});
parcelRegister("2m1xf", function(module, exports) {

$parcel$export(module.exports, "DropdownSelector", function () { return $ca8de50e57748f6a$export$67ffdcf8cfce0fd; });
/* dropdown-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $1K6UN = parcelRequire("1K6UN");
const $ca8de50e57748f6a$var$dropdownSelectorContainerStyle = null;
const $ca8de50e57748f6a$var$labelStyle = null;
const $ca8de50e57748f6a$var$labelStyleSignup = null;
const $ca8de50e57748f6a$export$67ffdcf8cfce0fd = ({ options: options, name: name, id: id, testId: testId, label: label, onChangeHandler: onChangeHandler, defaultValue: defaultValue, cssOverrides: cssOverrides, className: className })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $iSvIT.useState)(false);
    const elementID = id ? id : `${name}-dropdown`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c116y _2lx21bp4 _1bsb1osq",
            className
        ]),
        children: [
            (cssOverrides === null || cssOverrides === void 0 ? void 0 : cssOverrides.labelStyle) === "signup" && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                htmlFor: elementID,
                className: (0, $esG4f.default)([
                    "_syazvwuj _vwz41gnr _6rth1b66 _y3gn1e5h _k48pbfng _1wybdlk8"
                ]),
                children: label
            }),
            !(cssOverrides === null || cssOverrides === void 0 ? void 0 : cssOverrides.labelStyle) && /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                htmlFor: elementID,
                className: (0, $esG4f.default)([
                    "_syazvwuj _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "select-dropdown-container",
                "data-testid": testId ? testId : elementID,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1K6UN.default), {
                    defaultValue: defaultValue || {
                        label: "Select...",
                        value: ""
                    },
                    options: options,
                    unstyled: true,
                    inputId: elementID,
                    onChange: (selectedOption)=>{
                        onChangeHandler === null || onChangeHandler === void 0 ? void 0 : onChangeHandler((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || "");
                    },
                    onMenuOpen: ()=>setIsMenuOpen(true),
                    onMenuClose: ()=>setIsMenuOpen(false),
                    styles: {
                        // @ts-ignore
                        container: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                appearance: "none",
                                flexDirection: "row",
                                fontSize: "1rem",
                                lineHeight: "1.2",
                                textAlign: "left"
                            }), (cssOverrides || {}).container),
                        // @ts-ignore
                        singleValue: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)"
                            }), (cssOverrides || {}).singleValue),
                        // @ts-ignore
                        placeholder: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)"
                            }), (cssOverrides || {}).placeholder),
                        // @ts-ignore
                        valueContainer: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                paddingLeft: "var(--ds-space-075, 6px)",
                                paddingRight: "var(--ds-space-075, 6px)"
                            }), (cssOverrides || {}).valueContainer),
                        // @ts-ignore
                        menu: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                marginTop: "var(--ds-space-050, 4px)",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                boxShadow: "0px 3px 5px 0px #091E4233",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                background: "#ffffff",
                                padding: 0,
                                borderRadius: "var(--ds-space-050, 4px)"
                            }), (cssOverrides || {}).menu),
                        // @ts-ignore
                        control: (provided, state)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                "cursor": "pointer",
                                "backgroundColor": isMenuOpen ? "#253858" : "#FAFBFC",
                                "color": isMenuOpen ? "#ffffff" : "#172B4D",
                                "height": "2.65rem",
                                "border": state.isFocused ? `2px solid #4C9AFF` : `2px solid #dfe1e6`,
                                "borderRadius": "var(--ds-space-050, 4px)",
                                "&:hover": {
                                    background: isMenuOpen ? undefined : "#F4F5F7"
                                }
                            }), (cssOverrides || {}).control),
                        // @ts-ignore
                        dropdownIndicator: (provided, state)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                transition: "all .2s ease",
                                transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : undefined
                            }), (cssOverrides || {}).dropdownIndicator),
                        // @ts-ignore
                        indicatorsContainer: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                paddingTop: "var(--ds-space-075, 6px)",
                                paddingBottom: "var(--ds-space-075, 6px)",
                                paddingLeft: "var(--ds-space-025, 2px)",
                                paddingRight: "var(--ds-space-075, 6px)"
                            }), (cssOverrides || {}).indicatorsContainer),
                        // @ts-ignore
                        option: (provided, state)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                "cursor": "pointer",
                                "padding": `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
                                "whiteSpace": "pre-wrap",
                                "overflowWrap": "break-word",
                                "backgroundColor": state.isSelected ? "#B2D4FF" : state.isFocused ? "#EBECF0" : "#FAFBFC",
                                "color": state.isSelected ? "#0065FF" : "#172B4D",
                                "&:hover": {
                                    background: state.isSelected ? "#B2D4FF" : "#EBECF0"
                                },
                                "&:active": {
                                    // eslint-disable-next-line local/ensure-wac-token-usage
                                    background: "#DFE1E5"
                                }
                            }), (cssOverrides || {}).option),
                        // @ts-ignore
                        input: (provided)=>(0, $7Knp0._)((0, $6iHNw._)((0, $7Knp0._)({}, provided), {
                                color: "transparent"
                            }), (cssOverrides || {}).input)
                    }
                })
            })
        ]
    });
};

});


parcelRegister("1BHq9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2b2be59784c9b52b8b3b5b23f53d5b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $12baed95ccc7a34c$var$_react = $12baed95ccc7a34c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $12baed95ccc7a34c$var$_baseNew = $12baed95ccc7a34c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $12baed95ccc7a34c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $12baed95ccc7a34c$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $12baed95ccc7a34c$var$_react.default.createElement($12baed95ccc7a34c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$12baed95ccc7a34c$var$PersonAddedIcon.displayName = "PersonAddedIcon";
var $12baed95ccc7a34c$var$_default = module.exports.default = $12baed95ccc7a34c$var$PersonAddedIcon;

});

parcelRegister("fkwrS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b291e4eada3682d9$var$_react = $b291e4eada3682d9$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b291e4eada3682d9$var$_baseNew = $b291e4eada3682d9$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b291e4eada3682d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b291e4eada3682d9$var$PhoneIcon = (props)=>/*#__PURE__*/ $b291e4eada3682d9$var$_react.default.createElement($b291e4eada3682d9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$b291e4eada3682d9$var$PhoneIcon.displayName = "PhoneIcon";
var $b291e4eada3682d9$var$_default = module.exports.default = $b291e4eada3682d9$var$PhoneIcon;

});

parcelRegister("7ZFBY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d1e8213996c7b0a$var$_react = $5d1e8213996c7b0a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5d1e8213996c7b0a$var$_baseNew = $5d1e8213996c7b0a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5d1e8213996c7b0a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d1e8213996c7b0a$var$WarningIcon = (props)=>/*#__PURE__*/ $5d1e8213996c7b0a$var$_react.default.createElement($5d1e8213996c7b0a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$5d1e8213996c7b0a$var$WarningIcon.displayName = "WarningIcon";
var $5d1e8213996c7b0a$var$_default = module.exports.default = $5d1e8213996c7b0a$var$WarningIcon;

});

parcelRegister("guk0p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c00ef75bf5693ff4$var$_react = $c00ef75bf5693ff4$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c00ef75bf5693ff4$var$_baseNew = $c00ef75bf5693ff4$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c00ef75bf5693ff4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c00ef75bf5693ff4$var$TimelineIcon = (props)=>/*#__PURE__*/ $c00ef75bf5693ff4$var$_react.default.createElement($c00ef75bf5693ff4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$c00ef75bf5693ff4$var$TimelineIcon.displayName = "TimelineIcon";
var $c00ef75bf5693ff4$var$_default = module.exports.default = $c00ef75bf5693ff4$var$TimelineIcon;

});


var $lgDo7 = parcelRequire("lgDo7");

var $f788Q = parcelRequire("f788Q");
(0, $f788Q.init)((0, $lgDo7.UniformEntryPage));


//# sourceMappingURL=uniform-entry-page.f4d0c789.js.map
